module.exports = __webpack_public_path__ + "static/media/fast-food-gastronomy-svgrepo-com.ab5097de.svg";